import {Button} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React, {useCallback} from 'react';
import {TagChip} from 'presentation/components';
import {DataContentCard} from '../../../../components/DataContentCard';
import {
	StyledButtonsContainer,
	StyledCard,
	StyledDataContent,
	StyledHeaderContainer,
	StyledTitle,
} from './styles';
import {ExamCardType} from './types';

const {showDetails} = translations['pt-br'].commons;

const {doctor, hospital, releaseDate, requestDate} =
	translations['pt-br'].privateFlow.myHospitalization.exams.card;

export const ExamCard = ({exam, dataTestId}: ExamCardType) => {
	const handleFormatDate = useCallback(() => {
		let titleDate = '';
		if (exam.handleOpenDetails) {
			titleDate = releaseDate;
		} else {
			titleDate = requestDate;
		}
		const examTime = exam.examTime ? ` às ${exam.examTime}` : '';
		return {
			titleDate,
			descriptionDate: `${exam.examDate}${examTime}`,
		};
	}, [exam.examDate, exam.examTime, exam.handleOpenDetails]);
	const {titleDate, descriptionDate} = handleFormatDate();

	return (
		<StyledCard data-test-id={dataTestId}>
			<StyledHeaderContainer>
				<StyledTitle variant="h6">{exam.examName}</StyledTitle>
				{exam.handleOpenDetails ? null : <TagChip label={exam.examType} color="default" />}
			</StyledHeaderContainer>
			<StyledDataContent>
				<DataContentCard
					iconName="stethoscope"
					title={doctor}
					description={exam.doctorName}
				/>
				{exam.hospitalName ? (
					<DataContentCard
						iconName="location-default"
						title={hospital}
						description={exam.hospitalName}
					/>
				) : null}
				<DataContentCard
					iconName="query-builder-filled"
					title={titleDate}
					description={descriptionDate}
				/>
			</StyledDataContent>

			{exam.handleOpenDetails ? (
				<StyledButtonsContainer>
					<Button
						variant="contained"
						size="small"
						fullWidth
						onClick={exam.handleOpenDetails}>
						{showDetails}
					</Button>
				</StyledButtonsContainer>
			) : null}
		</StyledCard>
	);
};
